var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * CompsApiDetail 通用API接口详情面板组件
 * 用于显示接口的详细信息，包括参数和响应结构
 */
import React from "react";
import { Table, Typography, Tag, Space, Card } from "antd";
import { COMPONENT_OUTLINE_BORDER } from "../theme/componentBorders";
var Title = Typography.Title, Text = Typography.Text;
// 方法颜色映射
var METHOD_COLORS = {
    GET: "blue",
    POST: "green",
    PUT: "orange",
    DELETE: "red",
    PATCH: "purple",
};
var CompsApiDetail = function (_a) {
    var _b = _a.title, title = _b === void 0 ? "接口详情" : _b, api = _a.api, _c = _a.height, height = _c === void 0 ? "100%" : _c;
    // 参数表格列配置
    var paramColumns = [
        {
            title: "参数名",
            dataIndex: "name",
            key: "name",
            width: 150,
            render: function (text, record) { return (_jsxs(Space, { children: [_jsx(Text, __assign({ strong: true }, { children: text })), record.required && _jsx(Tag, __assign({ color: "red" }, { children: "\u5FC5\u586B" }))] })); },
        },
        {
            title: "类型",
            dataIndex: "type",
            key: "type",
            width: 100,
            render: function (text) { return _jsx(Tag, __assign({ color: "cyan" }, { children: text })); },
        },
        {
            title: "描述",
            dataIndex: "description",
            key: "description",
        },
        {
            title: "示例值",
            dataIndex: "example",
            key: "example",
            width: 150,
            render: function (text) { return (text ? _jsx(Text, __assign({ code: true }, { children: text })) : "-"); },
        },
    ];
    // 响应字段表格列配置
    var responseColumns = [
        {
            title: "字段名",
            dataIndex: "name",
            key: "name",
            width: 200,
            render: function (text) { return _jsx(Text, __assign({ code: true }, { children: text })); },
        },
        {
            title: "类型",
            dataIndex: "type",
            key: "type",
            width: 100,
            render: function (text) { return _jsx(Tag, __assign({ color: "cyan" }, { children: text })); },
        },
        {
            title: "描述",
            dataIndex: "description",
            key: "description",
        },
        {
            title: "示例值",
            dataIndex: "example",
            key: "example",
            width: 150,
            render: function (text) { return (text ? _jsx(Text, __assign({ code: true }, { children: text })) : "-"); },
        },
    ];
    return (_jsx(Card, __assign({ title: title, style: {
            flex: 1,
            height: height,
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
        }, bodyStyle: { flex: 1, overflow: "auto", padding: 16 } }, { children: api ? (_jsxs("div", __assign({ style: { height: "100%", overflow: "auto" } }, { children: [_jsxs(Space, __assign({ direction: "vertical", size: 16, style: { width: "100%", marginBottom: "24px" } }, { children: [_jsxs("div", { children: [_jsx(Title, __assign({ level: 4, style: { marginTop: 0, marginBottom: "8px" } }, { children: _jsxs(Space, { children: [_jsx(Tag, __assign({ color: METHOD_COLORS[api.method] }, { children: api.method })), api.name] }) })), _jsx(Text, __assign({ type: "secondary" }, { children: api.description }))] }), _jsxs("div", { children: [_jsx(Text, __assign({ strong: true }, { children: "\u63A5\u53E3\u8DEF\u5F84\uFF1A" })), _jsx(Text, __assign({ code: true, style: { fontSize: "14px", marginLeft: "8px" } }, { children: api.path }))] }), api.requiredPermission && (_jsxs("div", { children: [_jsx(Text, __assign({ strong: true }, { children: "\u6240\u9700\u6743\u9650\uFF1A" })), _jsx(Tag, __assign({ color: "gold", style: { marginLeft: "8px" } }, { children: api.requiredPermission }))] }))] })), api.pathParams && api.pathParams.length > 0 && (_jsxs("div", __assign({ style: { marginBottom: "24px" } }, { children: [_jsx(Title, __assign({ level: 5 }, { children: "Path \u53C2\u6570" })), _jsx(Table, { size: "small", columns: paramColumns, dataSource: api.pathParams, pagination: false, rowKey: "name", bordered: true })] }))), api.queryParams && api.queryParams.length > 0 && (_jsxs("div", __assign({ style: { marginBottom: "24px" } }, { children: [_jsx(Title, __assign({ level: 5 }, { children: "Query \u53C2\u6570" })), _jsx(Table, { size: "small", columns: paramColumns, dataSource: api.queryParams, pagination: false, rowKey: "name", bordered: true })] }))), api.bodyParams && api.bodyParams.length > 0 && (_jsxs("div", __assign({ style: { marginBottom: "24px" } }, { children: [_jsx(Title, __assign({ level: 5 }, { children: "Body \u53C2\u6570" })), _jsx(Table, { size: "small", columns: paramColumns, dataSource: api.bodyParams, pagination: false, rowKey: "name", bordered: true })] }))), _jsxs("div", __assign({ style: { marginBottom: "24px" } }, { children: [_jsx(Title, __assign({ level: 5 }, { children: "\u54CD\u5E94\u6570\u636E\u7ED3\u6784" })), _jsx(Table, { size: "small", columns: responseColumns, dataSource: api.responseFields, pagination: false, rowKey: "name", bordered: true })] })), api.responseExample && (_jsxs("div", __assign({ style: { marginBottom: "24px" } }, { children: [_jsx(Title, __assign({ level: 5 }, { children: "\u54CD\u5E94\u6570\u636E\u793A\u4F8B" })), _jsx(Card, __assign({ size: "small", style: {
                                backgroundColor: "#f5f5f5",
                                border: COMPONENT_OUTLINE_BORDER,
                            }, bodyStyle: { padding: "12px" } }, { children: _jsx("pre", __assign({ style: {
                                    margin: 0,
                                    padding: 0,
                                    fontSize: "13px",
                                    lineHeight: "1.6",
                                    fontFamily: "Monaco, Menlo, 'Ubuntu Mono', Consolas, 'source-code-pro', monospace",
                                    whiteSpace: "pre-wrap",
                                    wordBreak: "break-word",
                                    overflow: "auto",
                                    maxHeight: "400px",
                                    color: "#333",
                                } }, { children: api.responseExample })) }))] })))] }))) : (_jsx("div", __assign({ style: { textAlign: "center", padding: "50px" } }, { children: _jsx(Text, __assign({ type: "secondary" }, { children: "\u8BF7\u9009\u62E9\u5DE6\u4FA7\u63A5\u53E3\u67E5\u770B\u8BE6\u60C5" })) }))) })));
};
export default CompsApiDetail;
